"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadOffPageConnectorGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrCadOffPageConnectorGroupingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
        this.objectIds = new WeakMap();
        this.nextObjectId = 1;
    }
    apply(manager, hierarchy) {
        this.mergeOffPageConnectors(manager, hierarchy);
        return manager;
    }
    mergeOffPageConnectors(manager, hierarchy) {
        this.bucketAndMergeOffPagesAcross(manager, [hierarchy.instance]);
        const childrenByFolder = new Map();
        for (const child of hierarchy.children) {
            const key = this.folderKey(child.instance);
            const list = childrenByFolder.get(key) ?? [];
            list.push(child);
            childrenByFolder.set(key, list);
        }
        for (const siblings of childrenByFolder.values()) {
            if (siblings.length < 2) {
                continue;
            }
            this.bucketAndMergeOffPagesAcross(manager, siblings.map((s) => s.instance));
        }
        for (const child of hierarchy.children) {
            this.mergeOffPageConnectors(manager, child);
        }
    }
    bucketAndMergeOffPagesAcross(manager, instances) {
        const offPageBuckets = new Map();
        const hierarchicalPortBuckets = new Map();
        const aliasBuckets = new Map();
        for (const instance of instances) {
            for (const group of manager.findGroupsWithLabel('off-page-connector', undefined, instance)) {
                for (const label of group.getNetLabels(instance)) {
                    if (label.labelType !== 'off-page-connector') {
                        continue;
                    }
                    const name = label.formattedLabel ?? label.originalLabel;
                    if (!offPageBuckets.has(name)) {
                        offPageBuckets.set(name, new Set());
                    }
                    offPageBuckets.get(name).add(group);
                }
            }
            for (const group of manager.findGroupsWithLabel('hierarchical-port', undefined, instance)) {
                for (const label of group.getNetLabels(instance)) {
                    if (label.labelType !== 'hierarchical-port') {
                        continue;
                    }
                    const name = label.formattedLabel ?? label.originalLabel;
                    if (!hierarchicalPortBuckets.has(name)) {
                        hierarchicalPortBuckets.set(name, new Set());
                    }
                    hierarchicalPortBuckets.get(name).add(group);
                }
            }
            for (const group of manager.findGroupsWithLabel('alias', undefined, instance)) {
                for (const label of group.getNetLabels(instance)) {
                    if (label.labelType !== 'alias') {
                        continue;
                    }
                    const name = label.formattedLabel ?? label.originalLabel;
                    const bucket = aliasBuckets.get(name) ?? new Set();
                    bucket.add(group);
                    aliasBuckets.set(name, bucket);
                }
            }
        }
        for (const [name, offPageGroups] of offPageBuckets) {
            const matchingHierarchicalPortGroups = hierarchicalPortBuckets.get(name);
            const combined = new Set(offPageGroups);
            for (const group of aliasBuckets.get(name) ?? []) {
                const aliasInstances = [...group.getNets().keys()];
                if (!aliasInstances.some((instance) => [...offPageGroups].some((offPage) => offPage.hasLabelType('off-page-connector', instance)))) {
                    continue;
                }
                combined.add(group);
            }
            if (matchingHierarchicalPortGroups) {
                for (const g of matchingHierarchicalPortGroups) {
                    combined.add(g);
                }
            }
            if (combined.size <= 1) {
                continue;
            }
            manager.mergeGroups(...Array.from(combined));
        }
    }
    folderKey(instance) {
        const design = instance.hierarchyEntry.design;
        const schematic = instance.hierarchyEntry.schematic;
        return `${this.objectId(design)}::${this.objectId(schematic)}::${instance.pathUniqueId}`;
    }
    objectId(obj) {
        let id = this.objectIds.get(obj);
        if (id === undefined) {
            id = this.nextObjectId++;
            this.objectIds.set(obj, id);
        }
        return id;
    }
}
exports.OrCadOffPageConnectorGroupingRule = OrCadOffPageConnectorGroupingRule;
//# sourceMappingURL=OrcadOffPageConnectorGroupingRule.js.map